module.exports = __webpack_public_path__ + "static/timeline-a3bd6c9a78464fbd8d131ec8d9b685e8.png";